const TERMS_OF_USE = 'terms'
const PRIVACY_POLICY = 'privacy'
const COOKIES_POLICY = 'cookies'
const DELETION_POLICY = 'dataDeletion'

export default {
  TERMS_OF_USE,
  PRIVACY_POLICY,
  COOKIES_POLICY,
  DELETION_POLICY,
}
